import {Component, Input, OnInit} from "@angular/core";
import {DeviceModel} from "./device-model";
import {DeviceService} from "./device.service";

@Component({
	selector: "device-instructions",
	template: `
		<div *ngIf="content" class="form_instructions">
			<h3>How to Find The {{deviceModel.name}} {{deviceModel.displaySerialType}}:</h3>
			<div [innerHTML]="content"></div>
		</div>
	`,
})

export class DeviceInstructionsComponent implements OnInit  {

	@Input() deviceModel: DeviceModel;

	content: string;

	constructor(
		private deviceService: DeviceService,
	) {}

	ngOnInit() {
		this.deviceService.getDeviceInstructions(this.deviceModel.id).subscribe(deviceInstructions => {
			this.content =  deviceInstructions;
		});
	}
}
